import(/* webpackMode: "eager" */ "/app/src/app/(pages)/offerta-last-minute/error.tsx");
